// Constants Imports
import { strings } from '@/lib/data/site/strings';
import { mockRecipients } from '@/lib/data/global/recipients';

// Type Definitions
type EmailRequestBody = {
  to: string | string[];
  subject: string;
  replyTo: string | undefined;
  templatePath: string;
  placeholders: Record<string, string>;
};

type ContactUsBody = EmailRequestBody;

/**
 * sendContact Function
 * 
 * Sends a contact email to Specs support team.
 * 
 * @returns {Promise<boolean>} - Returns `true` if the message was sent successfully, otherwise `false`.
 */

type Inputs = {
  name: string;
  email: string;
  phone: string;
  message: string;
};

export const sendContactUs = async (formData: Inputs, isSender: boolean): Promise<boolean> => {
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || "https://specsonline.com";
  const siteBrandPath = (process.env.NEXT_PUBLIC_SYLIUS_CHANNEL_CODE || "SPECS").toLowerCase();
  //const recipientEmail = recipients[formData.recipient];
  const recipientEmail = mockRecipients.contactForm;

  try {
    const requestBody: ContactUsBody = {
      to: isSender ? formData.email : recipientEmail,
      subject: `${strings.brandNameShort} Contact Request`,
      templatePath: isSender ? "contactUsCustomerCopy.email" : "contactUs.email",
      replyTo: isSender? formData.email : '',
      placeholders: {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        phone: formData.phone,
        brandName: strings.brandName,
        brandNameShort: strings.brandNameShort,
        brandAddress: strings.brandAddress,
        year: new Date().getFullYear().toString(),
        url: `${siteUrl}/images/emails/${siteBrandPath}`,
      },
    };

    // Send email via backend API
    const response = await fetch('/api/messaging/email/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Failed to send contact email');
    }

    return true;
  } catch (error) {
    console.error("Error sending contact email:", error);
    return false;
  }
};
